import { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';
import { RadioCircle } from '../../../../../components/common/inputs/RadioCircle';
import { SlideConfirmModal } from '../../../../../components/common/modal/slide/SlideConfirmModal';
import { ampli } from '../../../../../ampli';

const JEONBUK_CITIES = [
  '전체',
  '전주시',
  '군산시',
  '익산시',
  '정읍시',
  '남원시',
  '김제시',
  '완주군',
  '진안군',
  '무주군',
  '장수군',
  '임실군',
  '순창군',
  '고창군',
  '부안군',
];

const STATES = ['전국', '전북특별자치도'];

interface SubsidyRegionFilterProps {
  selectedState: string;
  selectedCity: string;
  onStateChange: (state: string) => void;
  onCityChange: (city: string) => void;
}

export const SubsidyRegionFilter = ({
  selectedState,
  selectedCity,
  onStateChange,
  onCityChange,
}: SubsidyRegionFilterProps) => {
  const [isStateModalOpen, setIsStateModalOpen] = useState(false);
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);

  return (
    <>
      <FilterContainer>
        <FilterButton onClick={() => setIsStateModalOpen(true)}>
          <FilterButtonText>{selectedState}</FilterButtonText>
          <Icon name={'AngleDown'} width={12} height={12} fill={'#858894'} />
        </FilterButton>
        <FilterButton onClick={() => setIsCityModalOpen(true)}>
          <FilterButtonText>{selectedCity === '전체' ? '시 · 군' : selectedCity}</FilterButtonText>
          <Icon name={'AngleDown'} width={12} height={12} fill={'#858894'} />
        </FilterButton>
      </FilterContainer>

      {/* State Selection Modal */}
      <SlideConfirmModal
        isShow={isStateModalOpen}
        closeButton={{ handleClick: () => setIsStateModalOpen(false) }}
        isShowCloseButton
        element={
          <OptionList>
            {STATES.map((state) => (
              <OptionItem
                key={state}
                onClick={() => {
                  onStateChange(state);
                  setIsStateModalOpen(false);
                  ampli.pvmClickSubsidyLocationFilter({
                    state,
                    city: selectedCity,
                  });
                }}
              >
                <RadioCircle isSelected={selectedState === state} />
                <OptionText>{state}</OptionText>
              </OptionItem>
            ))}
          </OptionList>
        }
      />

      {/* City Selection Modal */}
      <SlideConfirmModal
        isShow={isCityModalOpen}
        closeButton={{ handleClick: () => setIsCityModalOpen(false) }}
        isShowCloseButton
        height={600}
        element={
          <OptionList>
            {JEONBUK_CITIES.map((city) => (
              <OptionItem
                key={city}
                onClick={() => {
                  onCityChange(city);
                  setIsCityModalOpen(false);
                  ampli.pvmClickSubsidyLocationFilter({
                    state: selectedState,
                    city,
                  });
                }}
              >
                <RadioCircle isSelected={selectedCity === city} />
                <OptionText>{city}</OptionText>
              </OptionItem>
            ))}
          </OptionList>
        }
      />
    </>
  );
};

const FilterContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
`;

const FilterButton = styled.button`
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  border-radius: 100px;
  background: #f2f2f7;
  border: none;
  cursor: pointer;

  &:active {
    background: #e5e5ea;
  }
`;

const FilterButtonText = styled.span`
  color: #505363;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 0;
  max-height: 500px;
  overflow-y: auto;
`;

const OptionItem = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 24px;
  gap: 12px;
  cursor: pointer;

  &:active {
    background: #f8f8fa;
  }
`;

const OptionText = styled.span`
  color: #232429;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
